import { render } from "./UserPlaylists.vue?vue&type=template&id=2e3551a7&scoped=true"
import script from "./UserPlaylists.vue?vue&type=script&lang=js"
export * from "./UserPlaylists.vue?vue&type=script&lang=js"

import "./UserPlaylists.vue?vue&type=style&index=0&id=2e3551a7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e3551a7"

export default script